export type IconGap = 'none' | 'xs' | 'sm' | 'xm' | 'md' | 'lg' | string
export function IconGapSizes(size: IconGap): string {
  switch (size) {
    case 'none':
      return ''
    case 'xs':
      return 'gap-x-0.5'
    case 'sm':
      return 'gap-x-1'
    case 'xm':
      return 'gap-x-1.5'
    case 'lg':
      return 'gap-x-3'
    case 'md':
    default:
      return 'gap-x-2'
  }
}
